import { Button, Menu, MenuItem } from "@mui/material";
import { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useParams, useLocation } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import Iconify from "../../../../../reusable-components/iconify";
import { updateSingleTicket } from "../../../../../redux/slices/tickets";
import { useScopeCheck } from "../../../../../reusable-components/scopes";
import RemindMeDialog from "./RemindMeDialog";

OptionsButton.propTypes = {
  setIsTicketInfoOpen: PropTypes.func,
  attachments: PropTypes.array,
  setAttachments: PropTypes.func,
  setIsAddingSubticket: PropTypes.func,
};

export default function OptionsButton({setIsTicketInfoOpen, attachments, setAttachments, setIsAddingSubticket}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [isRemindMeDialogOpen, setIsRemindMeDialogOpen] = useState(false);
  const fileInputRef = useRef(null);
  const { id } = useParams();
  const location = useLocation();
  const subticketId = new URLSearchParams(location.search).get('subticket');
  const { mainTicket, boomerang } = useSelector((state) => state.tickets.data.ticketInfoById[id] || {});
  const dispatch = useDispatch();
  const isManager = useScopeCheck(["Facility-Manager"]);

  const handleAddAttachment = () => {
    setMenuAnchorEl(null);
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const fileList = [];
    files.forEach((file) => {
      if (attachments?.some((x) => x.name === file.name)) {
        enqueueSnackbar(`File ${file.name} already exists.`, {variant: 'error'});
      }
      else fileList.push(file);
    });
    setAttachments([...attachments, ...fileList]);
  };

  const handleRemindMe = () => {
    setIsRemindMeDialogOpen(true);
    setMenuAnchorEl(null);
  }

  const iconStyle = {
    mr: 0.5,
    fontSize: 24,
    width: 24,
    height: 24,
  }

  return <>
    <Button
      sx={{
        minWidth: 0,
        ml: 0.5,
        height: 28,
        minHeight: 28,
        p: 1,
      }}
      color="info"
      variant="contained"
      onClick={(event) => setMenuAnchorEl(event.currentTarget)}
    >
      <Iconify icon="mdi:dots-horizontal" />
    </Button>
    <Menu
      anchorEl={menuAnchorEl}
      open={Boolean(menuAnchorEl)}
      onClose={() => setMenuAnchorEl(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem sx={{margin: 0}} onClick={handleAddAttachment}>
        <Iconify
          icon="mdi:paperclip"
          color="secondary"
          sx={iconStyle}
        />
        Add Attachment
      </MenuItem>
      {mainTicket && !mainTicket.locked && <MenuItem sx={{ margin: 0 }} onClick={() => {
        setIsTicketInfoOpen(true);
        setIsAddingSubticket(true);
        setMenuAnchorEl(null);
      }}>
        <Iconify
          icon="mdi:plus"
          color="secondary"
          sx={iconStyle}
        />
        Add Subticket
      </MenuItem>}
      {mainTicket && isManager && id && !subticketId && (
      <MenuItem sx={{margin: 0}} onClick={handleRemindMe}>
        <Iconify
          icon="mdi:clock"
          color={boomerang?.boomerangOn ? "info" : "secondary"}
          sx={iconStyle}
        />
        Remind Me
      </MenuItem>
    )}
    </Menu>
    <RemindMeDialog
      open={isRemindMeDialogOpen}
      onClose={() => setIsRemindMeDialogOpen(false)}
      ticket={mainTicket}
      boomerang={boomerang}
      unpinTicket={(date) => dispatch(updateSingleTicket({ ...mainTicket, boomerangOn: date, aboveLine: false }))}
    />
    <input
      type="file"
      ref={fileInputRef}
      style={{ display: 'none' }}
      multiple
      onChange={handleFileChange}
    />
  </>
}